export default __webpack_public_path__ + "locales/vi/People.json?hash=0daabe55f219fd8245756534c5246af9";